import { useQuery, useMutation } from 'convex/react';
import { api } from '../../convex/_generated/api';
import type { Id } from '../../convex/_generated/dataModel';

export function useFitnessResultsForSession(sessionId: string) {
  const data = useQuery(
    api.coach.fitnessResults.getForSession,
    sessionId ? { sessionId: sessionId as Id<"trainingSessions"> } : 'skip'
  );
  return { data: data ?? [], isLoading: data === undefined };
}

export function useFitnessLatestPerPlayer(
  playerIds: string[],
  testType: string,
  beforeDate: string,
) {
  const data = useQuery(
    api.coach.fitnessResults.getLatestPerPlayer,
    playerIds.length > 0 && testType && beforeDate
      ? {
          playerIds: playerIds as Id<"players">[],
          testType,
          beforeDate,
        }
      : 'skip'
  );
  return { data: data ?? [], isLoading: data === undefined };
}

export function useBulkUpsertFitnessResults() {
  const mutate = useMutation(api.coach.fitnessResults.bulkUpsert);
  return {
    mutateAsync: (args: {
      sessionId?: string;
      testType: string;
      customTestName?: string;
      unit: string;
      date: string;
      results: Array<{ playerId: string; value: number; notes?: string }>;
    }) =>
      mutate({
        sessionId: args.sessionId as Id<"trainingSessions"> | undefined,
        testType: args.testType,
        customTestName: args.customTestName,
        unit: args.unit,
        date: args.date,
        results: args.results.map((r) => ({
          playerId: r.playerId as Id<"players">,
          value: r.value,
          notes: r.notes,
        })),
      }),
  };
}

export function useDeleteFitnessResult() {
  const mutate = useMutation(api.coach.fitnessResults.removeResult);
  return {
    mutateAsync: (resultId: string) =>
      mutate({ resultId: resultId as Id<"playerFitnessResults"> }),
  };
}

export function useFitnessLeaderboard(testType: string) {
  const data = useQuery(
    api.coach.leaderboards.listFitness,
    testType ? { testType } : 'skip'
  );
  return { data: data ?? [], isLoading: data === undefined };
}
